// extracted by mini-css-extract-plugin
export default {"loginButtonsRow":"LoginButtons_loginButtonsRow__Itkwt"};